import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import * as pbi from "powerbi-client";
import { useEffect, useState } from 'react';
import { ConfigBI } from "../../configs/ConfigBI";
import "./powerBi.css";

const pbiUrl = 'https://app.powerbi.com/reportEmbed?';
const pbiConfigParam = '&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZSwiZGlzYWJsZUFuZ3VsYXJKU0Jvb3RzdHJhcFJlcG9ydEVtYmVkIjp0cnVlfX0%3d';

const PBIReport = (props) => {
    const [renderFlag, setrenderFlag] = useState(false);
    const [valueFilter, setValueFilter] = useState([]);

    const models = pbi.models;
    const customCss = props?.customCss ?? 'default-pbicss';

    const pbiConfig = {
        type: 'report',   // Supported types: report, dashboard, tile, visual and qna
        tokenType: models.TokenType.Aad,
        accessToken: props.BiToken,
        embedUrl: `${pbiUrl}reportId=${props.reportId}${pbiConfigParam}`,

        permissions: models.Permissions.Read.All,
        id: props.reportId,

        settings: {
            layoutType: models.LayoutType.Custom,
            customLayout: {
                displayOption: models.DisplayOption.FitToWidth
            },
            panes: {
                filters: {
                    expanded: false,
                    visible: true
                },
                pageNavigation: {
                    visible: false
                },
            },
        },
        filters: [
            {
                $schema: "http://powerbi.com/product/schema#basic",
                target: {
                    table: props?.filterTable ?? '', // "Product Hierarchy",
                    column: props?.filterColumn ?? '' //"ISBN"
                },
                operator: valueFilter && valueFilter?.length > 0 ? "In" : "All",
                values: valueFilter,
                filterType: models.FilterType.BasicFilter,
                requireSingleSelection: true
            },
        ]
    };

    useEffect(() => {
        try {
            if (props?.filterValues && props?.filterValues.length > 0) {
                setValueFilter(props?.filterValues ?? []);
                setrenderFlag(prev => !prev);
            } else {
                setValueFilter([]);
            }
        }
        catch ({ name, message }) {
            console.warn('Failed to get filter values.');
        }
    }, [props.filterValues])

    useEffect(() => {
        try {
            if (props?.filterValue) {
                setValueFilter([props?.filterValue]);
                setrenderFlag(prev => !prev);
            } else {
                setValueFilter([]);
            }
        }
        catch ({ name, message }) {
            console.warn('Failed to get filter value.');
        }
    }, [props.filterValue])


    return (<>
        {props.BiToken == '' ? <>Loading...</> :
            <PowerBIEmbed
                embedConfig={pbiConfig}
                eventHandlers={
                    new Map([
                        ['loaded', (event) => console.log(`${props?.name} loaded`, event)],
                        ['rendered', (event) => console.log(`${props?.name} rendered`, event)],
                        ['error', (event) => console.log(`${props?.name} error`, event)],
                        ['visualClicked', (event) => console.log(`${props?.name} visualClicked`, event)],
                        ['pageChanged', (event) => console.log(`${props?.name} pageChanged`, event)],
                        ['dataSelected', (event) => console.debug(`${props?.name} Report dataSelected`, event?.detail?.dataPoints)],
                    ])}
                cssClassName={`Embed-container ${customCss}`}
                key={renderFlag ? "key1" : "key2"}
            />}

    </>

    );
};
export default PBIReport;
